import Svg, { Props } from '../svg/Svg';

const GraphicEmptyCard = ({ width = 222, height = 216, viewBox = '0 0 222 216', ...rest }: Props) => {
  return (
    <Svg width={width} height={height} viewBox={viewBox} {...rest}>
      <g opacity="0.2">
        <ellipse opacity="0.6" cx="31.7893" cy="188.975" rx="28.2424" ry="3.05324" fill="#C7C7D0" />
        <ellipse opacity="0.8" cx="124.408" cy="207.454" rx="79.2911" ry="8.5443" fill="#C7C7D0" />
        <g opacity="0.6">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.9562 137.661C35.8482 136.869 40.7933 130.64 40.0013 123.748C39.2094 116.856 32.9804 111.911 26.0884 112.703C19.1964 113.495 14.2514 119.724 15.0433 126.616C15.8352 133.508 22.0643 138.453 28.9562 137.661ZM27.8659 128.209C29.5366 128.017 30.7355 126.506 30.5435 124.836C30.3515 123.165 28.8414 121.966 27.1706 122.158C25.4999 122.35 24.301 123.86 24.493 125.531C24.685 127.202 26.1951 128.401 27.8659 128.209Z"
            fill="#9090A0"
          />
          <rect
            x="6.69531"
            y="118.371"
            width="11.0843"
            height="36.6221"
            rx="3.10356"
            transform="rotate(-22.1155 6.69531 118.371)"
            fill="#464656"
          />
          <rect
            x="1.4375"
            y="128.184"
            width="52.909"
            height="52.5284"
            rx="7.61281"
            transform="rotate(-6.55488 1.4375 128.184)"
            fill="#C7C7D0"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M135.28 43.4072C144.662 44.5021 153.156 37.7841 154.251 28.4021C155.346 19.02 148.628 10.5268 139.245 9.43181C129.863 8.33685 121.37 15.0549 120.275 24.4369C119.18 33.8189 125.898 42.3122 135.28 43.4072ZM136.78 30.5353C139.055 30.8007 141.114 29.1721 141.379 26.8977C141.644 24.6232 140.016 22.5643 137.741 22.2988C135.467 22.0334 133.408 23.662 133.143 25.9364C132.877 28.2108 134.506 30.2698 136.78 30.5353Z"
          fill="#9090A0"
        />
        <rect
          x="97.2344"
          y="8.88672"
          width="101.447"
          height="141.498"
          rx="11.2379"
          transform="rotate(12.9128 97.2344 8.88672)"
          fill="#464656"
        />
        <path d="M120.75 24.7969L132.59 26.1787" stroke="#464656" strokeWidth="1.516" strokeLinecap="round" />
        <path d="M141.859 27.2578L153.699 28.6396" stroke="#464656" strokeWidth="1.516" strokeLinecap="round" />
        <path
          d="M45.1492 113.881C46.7625 100.058 59.2764 90.1594 73.0998 91.7727L76.1426 92.1278C91.0502 93.8676 101.725 107.363 99.985 122.271L96.261 154.179C95.7428 158.62 91.7229 161.8 87.2824 161.281L52.7725 157.254C45.8608 156.447 40.9116 150.19 41.7183 143.278L45.1492 113.881Z"
          fill="#9090A0"
        />
        <path
          d="M207.844 132.873C209.458 119.05 199.56 106.536 185.736 104.923L182.693 104.568C167.786 102.828 154.29 113.502 152.55 128.41L148.826 160.319C148.308 164.759 151.488 168.779 155.928 169.297L190.438 173.325C197.35 174.131 203.607 169.182 204.414 162.271L207.844 132.873Z"
          fill="#9090A0"
        />
        <path
          d="M66.6191 82.1402C70.6523 47.5816 101.937 22.836 136.496 26.8692L138.999 27.1613C173.557 31.1946 198.303 62.4794 194.27 97.0379L185.637 171.008C184.435 181.302 175.116 188.673 164.823 187.472L74.4496 176.925C64.1557 175.723 56.7848 166.404 57.9862 156.111L66.6191 82.1402Z"
          fill="#C7C7D0"
        />
        <path
          d="M168.125 173.612L171.664 143.289C174.729 117.025 155.922 93.2482 129.658 90.183C103.393 87.1177 79.6167 105.924 76.5514 132.189L73.0126 162.511C72.0631 170.647 77.8885 178.012 86.024 178.961L151.675 186.623C159.81 187.573 167.175 181.747 168.125 173.612Z"
          fill="#E9E9EE"
        />
      </g>
    </Svg>
  );
};

export default GraphicEmptyCard;
